import { SubmissionError } from 'redux-form';

import * as removalApi from '../services/api/removal';

export function sendDataEnquiry(values) {
    return () => {
        return removalApi
            .sendDataEnqury(values)
            .catch(res => {
                throw new SubmissionError({
                    ...res.payload
                });
            });
    }
}